export default {"id":"da415236","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}